import React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import AddButton from "../../../../Componets/Buttons/add";
import { Input, DatePicker } from "antd";
import dayjs from "dayjs";

const DebitNoteTable = React.forwardRef(({
  details,
  onDetailChange,
  onRemoveDetail,
  onAddItem,
  totals,
  readOnly,
  selectedPurchaseOrder
}, ref) => {

  const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <div className="overflow-x-auto">
      <div className="w-[100%]">
        <table className="w-[100%]">
          <thead>
            <tr>
              <td className="border p-4 text-black">S.NO</td>
              <td className="border p-4 text-black">DESCRIPTION</td>
              <td className="border p-4 text-black">UNIT</td>
              <td className="border p-4 text-black">QUANTITY</td>
              <td className="border p-4 text-black">PURCHASE&nbsp;PRICE</td>
              <td className="border p-4 text-black">TAX&nbsp;[VAT]</td>
              <td className="border p-4 text-black">TOTAL</td>
              {!readOnly && <td className="border p-4 text-black">DELETE</td>}
            </tr>
          </thead>
          <tbody>
            {details?.map((value, index) => {
              return (
                <React.Fragment key={index}>
                  <tr>
                    <td className="border p-4 text-center text-gray-700">
                      {index + 1}
                    </td>
                    <td className="border p-4">
                      <div className="w-[300px]">{value?.name}</div>
                      <div className="w-[300px]">#Batch-{value?.batch}</div>
                    </td>
                    <td className="border p-4 text-center">
                      <div>{value?.unit_name}</div>
                    </td>
                    <td className="border p-4 text-center">
                      <div>
                        {readOnly ? (
                          <div className="border border-gray-200 p-2 rounded-md">
                            {value?.quantity}
                          </div>
                        ) : (
                          <Input
                            type="number"
                            className="w-full text-regular"
                            name="quantity"
                            placeholder="Quantity"
                            value={value?.quantity}
                            onChange={(e) => onDetailChange(index, 'quantity', e.target.value)}
                            autoComplete="off"
                            max={value?.original_quantity}
                          />
                        )}
                      </div>
                    </td>
                    <td className="border p-4 text-center">
                      <div>
                        <div className="border border-gray-200 p-2 rounded-md">
                          {value?.purchase_price?.toFixed(3)}
                        </div>
                      </div>
                    </td>
                    <td className="border p-4 text-center">
                      <div className="border border-gray-200 p-2 rounded-md">
                        {value?.tax_amount?.toFixed(3)}
                      </div>
                    </td>
                    <td className="border p-4 text-center text-gray-700">
                      {value?.total?.toFixed(3) || "0.000"}
                    </td>
                    {!readOnly && (
                      <td className="border p-4 text-center">
                        <button
                          type="button"
                          className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                          onClick={() => onRemoveDetail(index)}
                        >
                          <DeleteOutlined />
                        </button>
                      </td>
                    )}
                  </tr>

                </React.Fragment>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td className="border p-4" rowSpan={2} colSpan={readOnly ? 6 : 7}></td>
              {!readOnly && (
                <td className="border p-4" rowSpan={2} colSpan={1}>
                  <div className="text-center">
                    <AddButton
                      className={"form-save-button w-full h-full text-center"}
                      onClick={onAddItem}
                    />
                  </div>
                </td>
              )}
            </tr>
            <tr></tr>
            <tr>
              <td className="border p-4" colSpan={readOnly ? 5 : 6}></td>
              <td className="border p-4 text-gray-700">SUBTOTAL</td>
              <td className="border p-4" colSpan={readOnly ? 1 : 2}>
                {totals?.subtotal > 0 ? totals?.subtotal : "0.000"}
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={readOnly ? 5 : 6}></td>
              <td className="border p-4 text-gray-700">TAX&nbsp;[VAT]</td>
              <td className="border p-4" colSpan={readOnly ? 1 : 2}>
                {totals?.taxamount > 0 ? totals?.taxamount : "0.000"}
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={readOnly ? 5 : 6}></td>
              <td className="border p-4 text-gray-700">DISCOUNT&nbsp;</td>
              <td className="border p-4" colSpan={readOnly ? 1 : 2}>
                <div className="border border-gray-200 p-2 rounded-md">
                  {totals?.discount?.toFixed(3)}
                </div>
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={readOnly ? 5 : 6}></td>
              <td className="border p-4 text-gray-700">DELIVERY&nbsp;CHARGES</td>
              <td className="border p-4" colSpan={readOnly ? 1 : 2}>
                <div className="border border-gray-200 p-2 rounded-md">
                  {totals?.delivery?.toFixed(3)}
                </div>
              </td>
            </tr>
            <tr>
              <td className="border p-4" colSpan={readOnly ? 5 : 6}></td>
              <td className="border p-4 text-black text-medium">TOTAL</td>
              <td className="border p-4 text-black text-medium" colSpan={readOnly ? 1 : 2}>
                {totals?.total > 0 ? totals?.total : "0.000"}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
});


export default DebitNoteTable;